import React, { useState, useEffect, useCallback, useRef } from 'react';
import { Redirect, Link } from 'react-router-dom';
import HttpService from '../../services/httpService'
import { setLoading, setSnackInfo } from '../../redux/actions/appAction';
import { connect } from "react-redux";
import { setUserDetails } from '../../redux/actions/userAction'
import { useHistory } from 'react-router-dom';

import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import { ButtonGroup, FormControl } from '@material-ui/core';
import TextField from '@material-ui/core/TextField';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import Grid from '@material-ui/core/Grid';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { CSVLink } from "react-csv";
import '../../App.css'
import moment from 'moment'
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import FormLabel from '@material-ui/core/FormLabel';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import Switch from '@material-ui/core/Switch';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';


const useStyles = makeStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    // height: '100vh', // Make container full height of the viewport
    backgroundColor: '#2C2E3E',
    padding:"4rem",
    color: 'white', // Set text color to white
    borderRadius:"10px"
  },
  form: {
    width: '100%', // Make form width 100% of its container
    maxWidth: '300px', // Limit form width for larger screens
    textAlign: 'center', // Center align form elements
  },
  input: {
    // color: 'white',
    borderBottom: '1px solid #fff',
    borderRadius: '50px',
    marginBottom: '5%',
    height: '40px',
    padding: '0 15px', // Increase padding for better mobile responsiveness
    width: 'calc(100% - 30px)', // Make input width responsive
    maxWidth: 'calc(300px - 30px)', // Limit input width for larger screens
  },
  loginButton: {
    backgroundColor: 'white',
    color: '#2c2e3e',
    margin: '20px auto', // Center button horizontally with some vertical margin
    padding: '10px 20px',
    borderRadius: '50px',
    "&:hover": {
      backgroundColor: '#3f51b5',
      color: 'white',
    },
  },
  formBox:{
    border: '2px solid #3f51b5', // Border color
    borderRadius: '8px',          // Rounded corners
    padding: '10px',              // Space within the border
    margin: '5px 0',              // Space around the component
  },
  submitButton: {
    backgroundColor: '#F47E46',  // Decorpot Orange
    color: 'white',            // White text
    '&:hover': {
      backgroundColor: '#E0663D', // Darker Orange on hover
    },
},
  downloadButton: {
    backgroundColor: '#1C375D',   // Dark Blue
    color: '#FFFFFF',             // White text
    '&:hover': {
      backgroundColor: '#2A4B6C', // Lighter Dark Blue on hover
    },
},

  date:{
    width: '200px'
  }
});

const LeadBuilder = (props) => {
  const classes = useStyles();
  const {setRenderData} = props;
  const [formAutoFillValues, setFormAutoFillValues] = useState({});
  const [startDate, setStartDate] = useState(moment().subtract(2, 'months').format('YYYY-MM-DD')); // Today's date
  const [endDate, setEndDate] = useState(moment().format('YYYY-MM-DD')); 
  const [startDateRTDD, setStartDateRTDD] = useState("");
  const [endDateRTDD, setEndDateRTDD] = useState("");
  const [startDateESD, setStartDateESD] = useState("");
  const [endDateESD, setEndDateESD] = useState("");
  const [startDatePDSD, setStartDatePDSD] = useState("");
  const [endDatePDSD, setEndDatePDSD] = useState("");
  const [tokenPstart, setTokenPstart] = useState("");
  const [tokenPend, setTokenPend] = useState("");
  const [discountPstart, setDiscountPstart] = useState("");
  const [discountPend, setDiscountPend] = useState("");
  const [expanded, setExpanded] = useState(false);
  const [startDateSWD, setStartDateSWD] = useState("");
  const [endDateSWD, setEndDateSWD] = useState("");
  const [startDateMeeting, setStartDateMeeting] = useState("");
  const [endDateMeeting, setEndDateMeeting] = useState("");
  const [salesWonStart, setSalesWonStart] = useState("");
  const [salesWonEnd, setSalesWonEnd] = useState("");
  const [designSignOffValueStart, setDesignSignOffValueStart] = useState("");
  const [designSignOffValueEnd, setDesignSignOffValueEnd] = useState("");

  const [formData, setFormData] = useState({
    city: '',
    experienceCenterId: '',
    departmentId: '', 
    isRegistered: '',
    floorPlan: '',
    propertyType: '',
    scopeOfWork: '',
    startInteriors: '',
    salesWonExpCtrId: '',
    sourceOfLead: '',
    leadType: '',
    leadStatus: '',
    currentStage: '',
    lostStage: '',
    salesStage: '',
    executionStage: '',
    imosStage: '',
    factoryStage: '',
    designUser: '',
    // amountPaid: '',
    designStages:'',
    status: '',
    designStatus: '',
    designHoldReason: '',
    tenPercentPaid: '',
    designHoldSelectedTypes: '',
    teamId: '', 
    assignTo: '', 
    designUser: '', 
    designerAssigned: '',
    salesMeetingDone: '',
    isDesignKickOffCustomerApprovedFromDesign: '',
    salesUser: '',
    salesAssistantManager: '',
    salesManager: '',
    salesDGM: '',
  });

  const [open, setOpen] = React.useState(false);

  const handleSubmit = async (e) => {
    try{
      props.setLoading(true)
      e.preventDefault();
      const nullFilteredData = Object.fromEntries(Object.entries(formData).filter(([key, value]) => value !== '' && value !== null && (!Array.isArray(value) || value.length !== 0)));
      
      let idFilterData = Object.fromEntries(
        Object.entries(nullFilteredData).map(([key, fieldArr]) => 
          [
            key,
            Array.isArray(fieldArr) && fieldArr[0]?._id 
              ? fieldArr.map((el) => el._id) 
              : fieldArr
          ]
        )
      );
      
      const createdAt = {};
      if (startDate) {
        createdAt.$gte = startDate;
      }
      if (endDate) {
        createdAt.$lte = endDate;
      }
      
      const readyToDispatchDate = {};
      if (startDateRTDD) {
        readyToDispatchDate.$gte = startDateRTDD;
      }
      if (endDateRTDD) {
        readyToDispatchDate.$lte = endDateRTDD;
      }

      const expectedSalesclosureDate = {};
      if (startDateESD) {
        expectedSalesclosureDate.$gte = startDateESD;
      }
      if (endDateESD) {
        expectedSalesclosureDate.$lte = endDateESD;
      }

      const probableDesignSignOffDate = {};
      if (startDatePDSD) {
        probableDesignSignOffDate.$gte = startDatePDSD;
      }
      if (endDatePDSD) {
        probableDesignSignOffDate.$lte = endDatePDSD;
      }

      const tokenPercent = {};
      if (tokenPstart) {
        tokenPercent.$gte = tokenPstart
      }
      if (tokenPend) {
        tokenPercent.$lte = tokenPend
      }
      const discountPercent = {};
      if (discountPstart) {
        discountPercent.$gte = discountPstart;
      }
      if (discountPend) {
        discountPercent.$lte = discountPend;
      }

      const leadWonDate = {};
      if (startDateSWD) {
        leadWonDate.$gte = startDateSWD;
      }
      if (endDateSWD) {
        leadWonDate.$lte = endDateSWD;
      }
      const staticSalesWonAmount = {};
      if (salesWonStart) {
        staticSalesWonAmount.$gte = salesWonStart;
      }
      if (salesWonEnd) {
        staticSalesWonAmount.$lte = salesWonEnd;
      }
      const staticDesignWonAmount = {};
      if (designSignOffValueStart) {
        staticDesignWonAmount.$gte = designSignOffValueStart;
      }
      if (designSignOffValueEnd) {
        staticDesignWonAmount.$lte = designSignOffValueEnd;
      } 
      const meetingWithCustomer = {};
      if (startDateMeeting) {
        meetingWithCustomer.$gte = startDateMeeting;
      }
      if (endDateMeeting) {
        meetingWithCustomer.$lte = endDateMeeting;
      }

      if(Object.keys(createdAt).length>0){
        idFilterData = { ...idFilterData, createdAt };
      }
      if(Object.keys(readyToDispatchDate).length>0){
        idFilterData = { ...idFilterData, readyToDispatchDate };
      }
      if(Object.keys(expectedSalesclosureDate).length>0){
        idFilterData = { ...idFilterData, expectedSalesclosureDate };
      }
      if(Object.keys(probableDesignSignOffDate).length>0){
        idFilterData = { ...idFilterData, probableDesignSignOffDate };
      }
      if(Object.keys(tokenPercent).length>0){
        idFilterData = { ...idFilterData, tokenPercent };
      }
      if(Object.keys(discountPercent).length>0){
        idFilterData = { ...idFilterData, discountPercent };
      }

      if(Object.keys(leadWonDate).length>0){
        idFilterData = { ...idFilterData, leadWonDate };
      }
      if (Object.keys(meetingWithCustomer).length > 0) {
        idFilterData = {
          ...idFilterData,
          'meetingWithCustomer.meetingDate': meetingWithCustomer,
        };
      }
      if(Object.keys(staticSalesWonAmount).length>0){
        idFilterData = { ...idFilterData, staticSalesWonAmount };
      }
      if(Object.keys(staticDesignWonAmount).length>0){
        idFilterData = { ...idFilterData, staticDesignWonAmount };
      }

      const leadBuilderData = await HttpService.getLeadBuilderData(idFilterData);
      // console.log('leadBuilderData is ',leadBuilderData)
      // const copyArr = [...leadBuilderData.data];

      const csvarrdata = leadBuilderData.data.map((el) => {
        for (const key in el) {
          if(el[key]?.name){
            el[key] = el[key].name
          }
          else if(!isNaN(Date.parse(el[key])) && key.toLowerCase().includes('date')){
            const date = new Date(el[key]);
            el[key] = `${date.getDate()} ${date.toLocaleString('default', { month: 'short' })} ${date.getFullYear()}`;
          }
          else if(key === 'designHoldStatusApproval'){
            el[key] = `admApproval:${el[key]?.admApproval ?? 'N/A'} | odmApproval:${el[key]?.odmApproval ?? 'N/A'} | customerApproval:${el[key]?.customerApproval ?? 'N/A'}`
          }
          if(el[key]===''){
            el[key] = 'N/A'
          }
        }

        if (el.meetingWithCustomer) {
          el.meetingType = el.meetingWithCustomer.meetingType || 'N/A';
          el.meetingStage = el.meetingWithCustomer.meetingStage || 'N/A';
          el.meetingDate = el.meetingWithCustomer.meetingDate
              ? new Date(el.meetingWithCustomer.meetingDate).toISOString().split('T')[0]
              : 'N/A';
          delete el.meetingWithCustomer; // Remove nested object after extracting values
        }
        
        return el

      })
      // console.log('csvarrdata is',csvarrdata)
      setCsvData(csvarrdata);
      setRenderData(csvarrdata)
      if(leadBuilderData.data.length==0){
        props.setSnackInfo('No Data Found', "error")
      }
      props.setLoading(false)
  }
    catch(error){
      console.log(error)
    }
  };

  const getDataOnPageLoading = async()=>{
    const res = await HttpService.leadBuilderAutofillValues();
    setFormAutoFillValues(res.data);
  }

  const handleFormUpdate = (e,v,el)=>{
    setFormData({...formData, [el]:v})
  }
  const clearFilterDate = () => {
    setStartDate("");
    setEndDate("");
  };

  const setHeadingFun =()=>{
    setExpanded(!expanded)
  }
  

  function camelCaseToSentence(camelCaseStr){
    // Insert a space before each uppercase letter and capitalize the first letter
    const sentence = camelCaseStr.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase()); // Capitalize the first letter

    return sentence;
  }

  const csvButtonRef = useRef(null);
  const [headers, setHeaders] = useState([])
  const [csvData, setCsvData] = useState([]);

  const makeCSVdata = ()=>{
    let newArr = []
    for(const key in selectedFields)
    {
      if(selectedFields[key]){
        newArr.push({
          key:key,
          label: camelCaseToSentence(key)
        })
      }
    }
    setHeaders(newArr)
  }

  const csvDownloadHandler = async () => {
    setLoading(true);
    try {
        makeCSVdata()
        downloadExcel();
    } catch (error) {
        console.log("error", error);
        props?.setSnackInfo(
            error?.response?.data?.message ?? "Something went wrong",
            "error"
        );
    }
    setLoading(false);
};
const downloadExcel = () => {
    setLoading(true);
    try {
        setTimeout(() => {
            csvButtonRef.current.link.click();
        });
    } catch (err) {
        console.error(err.message);
    }
    setLoading(false);
};

const [selectedFields, setSelectedFields] = useState({
  lead_no: true,
  newUniqueLeadId: true,
  uniqueLeadNumber: true,
  createdAt: true,
  isRegistered: true,
  floorPlan: true,
  address: true,
  area: true,
  propertyType: true,
  scopeOfWork: true,
  startInteriors: true,
  city: true,
  experienceCenterId: true,
  salesWonExpCtrId: true,
  sourceOfLead: true,
  readyToDispatchDate: true,
  designUser: true,
  designStages: true,
  status: true,
  designStatus: true,
  designHoldReason: true,
  expectedDesignSignOffDate: true,
  assignTo: true,
  teamId: true,
  departmentId: true,
  customerId: true,
  designerAssigned: true,
  designerAssignedDate: true,
  contractSignedValue: true,
  designSignOffDate: true,
  internalDesignSignOffDate: true,
  designSignoffRevokeDate: true,
  expectedSalesclosureDate: true,
  discountPercent: true,
  tokenPercent: true,
  reasonForLost: true,
  imosToFactoryDate: true,
  salesMeetingDone: true,
  salesWonUser: true,
  daysAsPerContractSign: true,
  tenPercentPaid: true,
  amountReceivedInSales: true,
  amountReceivedInDesign: true,
  designSignOffUser: true,
  dateOfDesignKickOffMeeting: true,
  isDesignKickOffCustomerApprovedFromDesign: true,
  lastActivityDate: true,
  staticSalesWonBudget: true,
  probableDesignSignOffDate: true,
  customerDesignHoldRemark: true,
  designHoldSelectedTypes: true,
  designHoldStatusApproval: true,
  amountPaid: true,
  salesStage: true,
  salesUser: true,
  salesAssistantManager: true,
  salesManager: true,
  salesDGM: true,
  meetingDate: true,
  meetingStage: true,
  meetingType: true,
  leadWonDate: true,
  staticSalesWonAmount: true,
  staticDesignWonAmount: true,
});

const selectAllFun = ()=>{
  const updatedObject = {};
  for (const key in selectedFields) {
    if (selectedFields.hasOwnProperty(key)) {
      updatedObject[key] = true;
    }
  }
  setSelectedFields(updatedObject);

  const newArr = []
  for(const key in updatedObject)
    {
        newArr.push({
          key:key,
          label: camelCaseToSentence(key)
        })
    }
    setHeaders(newArr)
}
const deselectAllFun = ()=>{
  const updatedObject = {};
  for (const key in selectedFields) {
    if (selectedFields.hasOwnProperty(key)) {
      updatedObject[key] = false;
    }
  }
  setSelectedFields(updatedObject);
  setHeaders([])
}

const handleFieldSelectionChange = (event) => {
  const updatedObj = { ...selectedFields, [event.target.name]: event.target.checked }
  setSelectedFields(updatedObj);
  
  let newArr = []
    for(const key in updatedObj)
    {
      if(updatedObj[key]){
        newArr.push({
          key:key,
          label: camelCaseToSentence(key)
        })
      }
    }
    setHeaders(newArr)
};


  
  useEffect(()=>{
    getDataOnPageLoading()
    selectAllFun()
  },[])

  return (
    <>
    <FormControl className='tableContainer'>
    <form onSubmit={handleSubmit} key='builderForm'>
      <Grid container spacing={2}>
      
      <Grid 
      container 
      direction="row" 
      justifyContent="space-around" 
      alignItems="center" 
      spacing={3} 
      style={{marginBottom:'20px'}}
    >
      {/* Start Date 1 */}
      <Grid item md={2}>
        <TextField
          id="startDate"
          name="startDate"
          label="Created Start Date"
          type="date"
          value={startDate}
          onChange={(e) => setStartDate(e.target.value)}
          // fullWidth
          className={classes.date}
          InputLabelProps={{
            shrink: true,
          }}
        />
      </Grid>

      {/* End Date 1 */}
      <Grid item md={2}>
        <TextField
          id="endDate"
          name="endDate"
          label="Created End Date"
          type="date"
          value={endDate}
          onChange={(e) => setEndDate(e.target.value)}
          className={classes.date}
          InputLabelProps={{
            shrink: true,
          }}
        />
      </Grid>

      <Grid item>
        <Button 
          variant="contained" 
          color="secondary" 
          onClick={clearFilterDate}
        >
          Clear Filter
        </Button>
      </Grid>

      {/* Start Date 2 */}
      <Grid item md={2}>
        <TextField
          id="startDateDispatch"
          name="startDateDispatch"
          label="ReadyToDispatch Start Date"
          type="date"
          value={startDateRTDD}
          onChange={(e) => setStartDateRTDD(e.target.value)}
          className={classes.date}
          InputLabelProps={{
            shrink: true,
          }}
        />
      </Grid>

      {/* End Date 2 */}
      <Grid item md={2}>
        <TextField
          id="endDateDispatch"
          name="endDateDispatch"
          label="ReadyToDispatch End Date"
          type="date"
          value={endDateRTDD}
          onChange={(e) => setEndDateRTDD(e.target.value)}
          className={classes.date}
          InputLabelProps={{
            shrink: true,
          }}
        />
      </Grid>

      {/* Clear Filter Button */}
      <Grid item>
        <Button 
          variant="contained" 
          color="secondary" 
          onClick={() => {
            setStartDateRTDD("");
            setEndDateRTDD("");
          }}
        >
          Clear Filter
        </Button>
      </Grid>
      {/* Start Date 2 */}
      <Grid item md={2}>
        <TextField
          id="startDateSalesclosure"
          name="startDatSalesclosuree"
          label="Expected SalesClosure Start Date"
          type="date"
          value={startDateESD}
          onChange={(e) => setStartDateESD(e.target.value)}
          className={classes.date}
          InputLabelProps={{
            shrink: true,
          }}
        />
      </Grid>

      {/* End Date 2 */}
      <Grid item md={2}>
        <TextField
          id="endDateSalesclosure"
          name="endDateSalesclosure"
          label="Expected SalesClosure End Date"
          type="date"
          value={endDateESD}
          onChange={(e) => setEndDateESD(e.target.value)}
          className={classes.date}
          InputLabelProps={{
            shrink: true,
          }}
        />
      </Grid>

      {/* Clear Filter Button */}
      <Grid item>
        <Button 
          variant="contained" 
          color="secondary" 
          onClick={() => {
            setStartDateESD("");
            setEndDateESD("");
          }}
        >
          Clear Filter
        </Button>
      </Grid>
      {/* Start Date 2 */}
      <Grid item md={2}>
        <TextField
          id="startDateDesignSignOff"
          name="startDateDesignSignOff"
          label="Probable DesignSignOff Start Date"
          type="date"
          value={startDatePDSD}
          onChange={(e) => setStartDatePDSD(e.target.value)}
          className={classes.date}
          InputLabelProps={{
            shrink: true,
          }}
        />
      </Grid>

      {/* End Date 2 */}
      <Grid item md={2}>
        <TextField
          id="endDateDesignSignOff"
          name="endDateDesignSignOff"
          label="probable DesignSignOff End Date"
          type="date"
          value={endDatePDSD}
          onChange={(e) => setEndDatePDSD(e.target.value)}
          className={classes.date}
          InputLabelProps={{
            shrink: true,
          }}
        />
      </Grid>

      {/* Clear Filter Button */}
      <Grid item>
        <Button 
          variant="contained" 
          color="secondary" 
          onClick={() => {
            setStartDatePDSD("");
            setEndDatePDSD("");
          }}
        >
          Clear Filter
        </Button>
      </Grid>

           {/* THIS IS SALES WON FILTER */}
        {/* Start Won Date */}
        <Grid item md={2}>
          <TextField
            id="startDateSalesWonDate"
            name="startDateSalesWonDate"
            label="Lead Won Start Date"
            type="date"
            value={startDateSWD}
            onChange={(e) => setStartDateSWD(e.target.value)}
            className={classes.date}
            InputLabelProps={{
              shrink: true,
            }}
          />
        </Grid>
        {/* End Won Date */}
        <Grid item md={2}>
          <TextField
            id="endDateSalesWonDate"
            name="endDateSalesWonDate"
            label="Lead Won End Date"
            type="date"
            value={endDateSWD}
            onChange={(e) => setEndDateSWD(e.target.value)}
            className={classes.date}
            InputLabelProps={{
              shrink: true,
            }}
          />
        </Grid>
        {/* Clear Filter Button */}
        <Grid item>
          <Button 
            variant="contained" 
            color="secondary" 
            onClick={() => {
              setStartDateSWD("");
              setEndDateSWD("");
            }}
          >
            Clear Filter
          </Button>
        </Grid>
          {/* this is meeting Date */}
            {/* Start Won Date */}
            <Grid item md={2}>
              <TextField
                id="startMeetingDate"
                name="startMeetingDate"
                label="Meeting Start Date"
                type="date"
                value={startDateMeeting}
                onChange={(e) => setStartDateMeeting(e.target.value)}
                className={classes.date}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>
            {/* End Won Date */}
            <Grid item md={2}>
              <TextField
                id="endMeetingDate"
                name="endMeetingDate"
                label="Meeting End Date"
                type="date"
                value={endDateMeeting}
                onChange={(e) => setEndDateMeeting(e.target.value)}
                className={classes.date}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>
            {/* Clear Filter Button */}
            <Grid item>
              <Button 
                variant="contained"
                color="secondary" 
                onClick={() => {
                  setStartDateMeeting("");
                  setEndDateMeeting("");
                }}
              >
                Clear Filter
              </Button>
            </Grid>

          </Grid>

        {Object.keys(formData).map((el)=>(

          <Grid item xs={12} sm={4} md={2}>
          <Autocomplete
            multiple
            options={formAutoFillValues[el] || []}
            getOptionLabel={(option) => {
              if (typeof option === 'object' && option !== null) {
                  return option.name || "";
              }
              return option !== null ? option.toString() : "";
          }}          
            renderInput={(params) => (
              <TextField {...params} label={el === 'isDesignKickOffCustomerApprovedFromDesign' ? 'DKO Customer Approval Design' : el} name={el} />
            )}
            value={formData.el}
            onChange={(e,v)=> handleFormUpdate(e,v,el)}
            className={classes.autocomplete}
          />
        </Grid>
        
        ))}
        <Grid item xs={12} sm={4} md={2}></Grid>
        <Grid item xs={12} sm={4} md={2}></Grid>
        <Grid item xs={12} sm={4} md={2}></Grid>
        <Grid item xs={12} sm={4} md={2}></Grid>
        <Grid item xs={12} sm={4} md={2}></Grid>
        <Grid item xs={12} sm={4} md={2}></Grid>
        <Grid item xs={12} sm={4} md={2}></Grid>
        <Grid item xs={12} sm={4} md={2}></Grid>

        <Grid item xs={12} sm={4} md={2}>
          <Grid>
            <div style={{marginLeft:'80px', marginBottom:'20px'}}>Token Percent</div>
          </Grid>
          <Grid
          container
          direction="row"
          justifyContent="space-evenly"
          alignItems="flex-start"
          >
          <Grid item xs={12} sm={4} md={2}>
            <TextField
              id="TokenPercentStart"
              label="Start"
              type="number"
              value={tokenPstart}
              onChange={(e,v)=>setTokenPstart(e.target.value)}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
          <Grid item xs={12} sm={4} md={2}>
            <TextField
              id="TokenPercent"
              label="End"
              type="number"
              value={tokenPend}
              onChange={(e,v)=>setTokenPend(e.target.value)}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
          </Grid>

        </Grid>
        <Grid item xs={12} sm={4} md={2}>
          <Grid>
            <div style={{marginLeft:'80px', marginBottom:'20px'}}>Discount Percent</div>
          </Grid>
          <Grid
          container
          direction="row"
          justifyContent="space-evenly"
          alignItems="flex-start"
          >
          <Grid item xs={12} sm={4} md={2}>
            <TextField
              id="DiscountPercentStart"
              label="Start"
              type="number"
              value={discountPstart}
              onChange={(e,v)=>setDiscountPstart(e.target.value)}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
          <Grid item xs={12} sm={4} md={2}>
            <TextField
              id="DiscountPercentEnd"
              label="End"
              type="number"
              value={discountPend}
              onChange={(e,v)=>setDiscountPend(e.target.value)}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
          </Grid>

        </Grid>

        <Grid item xs={12} sm={4} md={2}>
          <Grid>
            <div style={{marginLeft:'50px', marginBottom:'20px'}}>Static Sales Won Amount</div>
          </Grid>
          <Grid
          container
          direction="row"
          justifyContent="space-evenly"
          alignItems="flex-start"
          >
          <Grid item xs={12} sm={4} md={2}>
            <TextField
              id="SalesWonValueStart"
              label="Start"
              type="number"
              value={salesWonStart}
              onChange={(e,v)=>setSalesWonStart(e.target.value)}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
          <Grid item xs={12} sm={4} md={2}>
            <TextField
              id="SalesWonValueEnd"
              label="End"
              type="number"
              value={salesWonEnd}
              onChange={(e,v)=>setSalesWonEnd(e.target.value)}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={4} md={2}>
          <Grid>
            <div style={{marginLeft:'50px', marginBottom:'20px'}}>Static Design Won Amount</div>
          </Grid>
          <Grid
          container
          direction="row"
          justifyContent="space-evenly"
          alignItems="flex-start"
          >
          <Grid item xs={12} sm={4} md={2}>
            <TextField
              id="DesignSignOffValueStart"
              label="Start"
              type="number"
              value={designSignOffValueStart}
              onChange={(e,v)=>setDesignSignOffValueStart(e.target.value)}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
          <Grid item xs={12} sm={4} md={2}>
            <TextField
              id="DesignSignOffValueEnd"
              label="End"
              type="number"
              value={designSignOffValueEnd}
              onChange={(e,v)=>setDesignSignOffValueEnd(e.target.value)}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
          </Grid>
        </Grid>

        <Grid container
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          style={{
            marginTop: "20px",
          }}
        >
        
        <Grid item xs={12} sm={4} md={2}></Grid>
        <Grid item xs={12} sm={4} md={1}>
          <Button type="submit" variant="contained"
            // className={classes.submitButton} 
            // style={{marginLeft: "90%" }} 
            className={classes.submitButton} 
            onClick={handleSubmit}>
          Submit
          </Button>
        </Grid>

        <Grid item xs={12} sm={4} md={2}>
          <CSVLink
                headers={headers}
                filename={"LeadBuilderData.csv"}
                data={csvData}
                ref={csvButtonRef}
              />
              <Button
                onClick={csvDownloadHandler}
                style={{
                  backgroundColor: "green",
                  color: "white",
                  width: "200px"
                }}
                // className={classes.downloadButton}
                variant="contained"
                className={classes.downloadButton}
              >
                Download CSV
              </Button>

        </Grid> 
        </Grid>

        <Grid item xs={12} sm={4} md={2} style={{ marginLeft: '83%' }}>
        <Button variant="outlined" color="secondary" onClick={() => {
          setOpen(true);
        }}
        style={{
          width: "200px",
          marginRight:'10px'
        }}
        >
          CSV Field Selection
          </Button>
        <Dialog onClose={() => {
            setOpen(false);
          }} aria-labelledby="customized-dialog-title" open={open}>
          <DialogTitle>Fields To Download In Excel</DialogTitle>
          <ButtonGroup variant="text" aria-label="text primary button group" style={{marginLeft:'90px'}}>
            <Button onClick={selectAllFun} color="secondary">Select All</Button>
            <Button onClick={deselectAllFun} color="primary">Deselect All</Button>
          </ButtonGroup>
          {Object.keys(selectedFields).map((el) => (
                  <FormControlLabel
                    style={{margin:'5px'}}
                    control={
                      <Switch
                        checked={selectedFields[el]} // Access using bracket notation
                        onChange={handleFieldSelectionChange}
                        name={el}
                      />
                    }
                    label={el}
                  />
                ))}
      </Dialog>
        </Grid>
      </Grid>
    </form>
    </FormControl>

    </>

  )
}

export default connect(null, { setLoading, setSnackInfo, setUserDetails })(LeadBuilder);